import React from 'react';
import ContentApp from '../../components/ContentApp';
import Header from '../../components/Common/Header/Header';
import UsersList from '../../components/Network/UsersList';

const MyNetworkUsers = () => {
  // const handleGoBack = () => {
  //   setInProp(false);
  // };

  // useEffect(() => {
  //   setInProp(true);
  // }, []);

  return (
    <>
      <Header />
      <ContentApp>
        <UsersList />
      </ContentApp>
    </>
  );
};

export default MyNetworkUsers;
